<template>
    <div>

        <div v-if="action.isCompleted">
            <ActionProviderMessageComplete :action="action"/>
        </div>

        <!-- Typeform inline widget -->
        <div id="wrapper" 
             :data-tf-widget="typeform" 
             data-tf-inline-on-mobile 
             data-tf-hide-headers 
             data-tf-medium="snippet"
             :style="css"
             v-else></div>

        <ActionProviderLoading :value="isLoading"/>

    </div>
</template>

<script>
import API from '@/api'

import moment from 'moment'

import actionProvider from '@/mixins/actionProvider'

export default 
{
   name: 'ActionProviderTypeform',

   mixins: [ actionProvider ],

   components: 
   {

   },

   data: () => ({
    hasListeners: false,
    isLoading: false,
    script: null
   }),

   props: {
    typeform: {
        type: String,
        required: true
    }
   },

   computed: 
   {
    css()
    {
        return {
            height: '650px'
        }
    },

   },

   methods:
   {

    addListeners()
    {
        if( this.hasListeners )
            return

        window.addEventListener("message", (e)=>{
            
            const eventType = e.data.type

            if( eventType !== 'form-submit' )
                return

            this.saveForm(e.data)

        })

        this.hasListeners = true
    },

    loadJs()
    {
        if( this.script )
            this.script.remove()

        let js = document.createElement('script')
            js.src = "//embed.typeform.com/next/embed.js"
            js.type = "text/javascript"

        document.body.appendChild(js)

        this.script = js
    },

    saveForm(payload)
    {
        this.isLoading = true

        const actionId = this.action.id,
              data = { payload }

        API.action.complete(actionId, data)
                  .then(({ data })=>{

                    this.$emit( 'completed', data )

                  })
                  .catch((err)=>{
                    
                    this.$emit( 'error', err )

                  })
                  .finally(()=>this.isLoading=false)
    },

    date(datetime)
    {
        return moment(datetime).format('DD/MM/YYYY')
    },

    time(datetime)
    {
        return moment(datetime).format('HH:mm')
    }

   },

   mounted()
   {
    this.loadJs()

    this.addListeners()
   }
}
</script>